import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-simple-page',
  templateUrl: './about-simple-page.component.html',
  styleUrls: ['./about-simple-page.component.scss']
})
export class AboutSimplePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
